import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Countdown({ startDate, endDate }) {
  const [time, setTime] = useState("");

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const start = new Date(startDate);
      const end = new Date(endDate);

      let target;
      let label;

      if (now < start) {
        target = start;
        label = "Starts In";
      } else if (now >= start && now <= end) {
        target = end;
        label = "";
      } else {
        setTime("0D 0H 0M 0S");
        return;
      }

      const diff = target - now;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTime(`${days}D ${hours}H ${minutes}M ${seconds}S`);
    };

    updateCountdown(); // inicia imediatamente
    const interval = setInterval(updateCountdown, 1000); // atualiza a cada segundo
    return () => clearInterval(interval);
  }, [startDate, endDate]);

  return <span style={{ color: "#fff", fontSize: 18 }}>{time}</span>;
}

const statStyle2 = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontSize: 21,
  width: 94,
  height: 56,
  backgroundImage: "url('/s2half.png')",
  backgroundSize: "94px 56px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  gap: 3
};

const statGrid = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: 15,
  maxWidth: 320
};

const pages = [
  {
    background: "/tournamentbg.png",
    buttonText: "Join The Tournament",
    content: (
      <>
        <div className="text-outline-white" style={{fontSize: 42, marginBottom: 5}}>
          The Tournament<br/>Has Begun!
        </div>

        <div style={{ position: 'relative', width: '100%', height: 350, marginTop: 20 }}>

          <motion.img
            src="/tournament1.png"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
            }}
            transition={{
          type: "spring",
          stiffness: 120,
          damping: 12
        }}
            initial={{ x: -300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          />

          <motion.img
            src="/tournament2.png"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              height: '100%',
            }}
            transition={{
          type: "spring",
          stiffness: 120,
          damping: 12
        }}
            initial={{ x: 300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          />

        </div>
      </>
    )
  },
  {
    background: "/bricks.png",
    buttonText: "Continue",
    content: (
      <>
       <div
  style={{
    width: 'calc(100% + 80px)',
    height: '110px',
    backgroundImage: "url('/tournamentbg2.png')",
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'relative',
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10
  }}
>
  <div className="text-outline-white" style={{ fontSize: 32 }}>
    The Grand Tournament
  </div>

  <div
  style={{
    borderRadius: 12,
    backgroundColor: "rgba(0,0,0,0.5)",
    padding: "6px 12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2
  }}
>
  <span style={{ color: "#FFBD48", fontSize: 18 }}>
    Tournament Ends In
  </span>

  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <img src="/newclock.png" style={{ height: 28 }} />
    <Countdown startDate="2026-03-10" endDate="2026-04-01" />
  </div>
</div>
</div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20
          }}
        >
          <div
           style={{
              width: '341px',
              height: '61px',
              backgroundImage: "url('/tournament.png')",
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              position: 'relative',
            }}
          >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: 18,
                  opacity: 0.85,
                }}
              >
                <div
                  style={{
                    color: '#FFD100',
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    height: '61px',
                    lineHeight: '69px',
                    textAlign: 'center',
                    width: '50%',
                  }}
                >
                  <b style={{ color: '#fff' }}>123</b> Wins
                </div>
                <div
                  style={{
                    color: '#FFD100',
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                    height: '61px',
                    lineHeight: '69px',
                    textAlign: 'center',
                    width: '50%',
                  }}
                >
                  <b style={{ color: '#fff' }}>123</b> Wins
                </div>
              </div>
          </div>
        </div>


        <div style={statGrid}>
          <div style={statStyle2}>
            <div>#24</div>
            <span style={{ fontSize: 16, color: "#FFC97F" }}>
              Global Rank
            </span>
          </div>

          <div style={statStyle2}>
            <div>152</div>
            <span style={{ fontSize: 16, color: "#FFC97F" }}>
              Wins
            </span>
          </div>

          <div style={statStyle2}>
            <div>#5</div>
            <span style={{ fontSize: 16, color: "#FFC97F" }}>
              Faction Rank
            </span>
          </div>

          <img src="/battlebt.png"/>

          <img src="/leaderboardlabel.png" style={{maxWidth: "300px"}}/>

          <div style={{borderRadius: 6,height: 42,lineHeight: "42px",width: "calc(100% / 3)",backgroundColor: "#DF5600"}}>Global Rank</div>
          <div style={{borderRadius: 6,height: 42,lineHeight: "42px",width: "calc(100% / 3)",backgroundColor: "#532102"}}>Your Faction</div>
          <div style={{borderRadius: 6,height: 42,lineHeight: "42px",width: "calc(100% / 3)",backgroundColor: "#532102"}}>Rival Faction</div>

        </div>
      </>
    ),
  },
];

export default function TournamentModal({ onClose, onNavigate }) {
  const [page, setPage] = useState(0);
  const [activeRank, setActiveRank] = useState(0); // 0 = Global Rank, 1 = Your Faction, 2 = Rival Faction

  const next = () => {
    if (page === pages.length - 1) {
      onClose();
    } else {
      setPage((p) => p + 1);
    }
  };

  const current = pages[page];

  console.log("onNavigate prop:", onNavigate);

  return (
    <div
        className="season-modal"
        style={{
          backgroundColor: "#000",
          backgroundImage: `url('${current.background}')`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >

          {page >= pages.length - 2 && (
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            top: 10,
            right: 10,
            cursor: "pointer",
            zIndex: 9999
          }}
        >
          <img src="/close.png" />
        </div>
      )}

      <AnimatePresence mode="wait">
        <motion.div
          key={page}
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -40 }}
          transition={{ duration: 0.25 }}
          className="season-modal-page"
        >
          <div className="season-content">
            {current.content}
          </div>

          <button onClick={() => {
            onClose(); 
    onNavigate('tournaments');
  }} disabled={page === pages.length - 1} style={{opacity: page === pages.length - 1 ? 0.5 : 1,cursor: page === pages.length - 1 ? "default" : "pointer", backgroundColor: "transparent", width: 236,height: 89, backgroundImage: "url('/cleanbig.png')",backgroundSize: '236px, 89px',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'}}>
            {current.buttonText}
          </button>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}